








































































import { Component, Prop, Mixins } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import BillableEntitiesInjectorMixin from "@/mixins/billableEntitiesInjectorMixin";

// Types
import { ICompany } from "@/models/companies";

@Component
export default class BillableCompanyEntity extends Mixins(
  BillableEntitiesInjectorMixin
) {
  @Prop({ required: true })
  public readonly company!: ICompany;

  // Props

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: true })
  public isSelectable!: boolean;

  @Prop({ default: false })
  public isSelected!: boolean;

  // Computed

  public get iconBindings() {
    if (this.company?.default)
      return {
        icon: "star",
        iconLabel: this.$t("_.default_company"),
        iconType: "is-info",
        multilined: false
      };
    return {};
  }

  // Methods

  public handleClick() {
    return this.isSelectable
      ? this.$emit("select", this.company)
      : this.$billableEntitiesMethods.manageClientCompany({
          company: this.company
        });
  }

  public copyToClipboard() {
    this.$copyToClipboard(
      _.compact([
        this.company.name,
        this.company?.address.address_1,
        this.company?.address.address_2,
        this.company?.address.city,
        this.company?.address.state,
        this.company?.address.postcode,
        this.company?.address?.country?.name
      ])
        .join(",\n")
        .trim()
    );
  }
}
